// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nFfc","top":"styles_top__2vxay"};